<div class="message-text mb-2">
  {{ message | translate }}
</div>
<div class="d-flex align-items-end">
    <button mat-raised-button color="primary" (click)="dismiss()">
      {{ 'common.ok' | translate }}
    </button>
</div>
